export default __webpack_public_path__ + "static/media/pfp2.558bae82.png";